import { getLoginType } from '@/libs/until'

const state = {
  activityReview: [],
  activityReviewDetail: {},
  activityReviewCount: [],
  setting: {}
}
const	getters = {
  getActivityReview: state => {
    return state.activityReview;
  },
  getActivityReviewDetail: state => {
    return state.activityReviewDetail;
  },
  getActivityReviewCount: state => {
    return [
      {
        name: `全部`,
        label: `全部 (${state.activityReviewCount.rl_count || 0})`,
        value: state.activityReviewCount.rl_count
      },
      {
        name: `活动待复盘`,
        label: `活动待复盘 (${state.activityReviewCount.ro_count || 0})`,
        value: state.activityReviewCount.ro_count
      },
      {
        name: `活动已复盘`,
        label: `活动已复盘 (${state.activityReviewCount.ru_count || 0})`,
        value: state.activityReviewCount.ru_count
      },
    ];
  },

}
const	mutations = {
  getactivityreview(state, payload) {
    state.activityReview = payload;
  },
  getactivityreviewcount(state, payload) {
    state.activityReviewCount = payload;
  },
  getactivityreviewdetail(state, payload) {
    state.activityReviewDetail = payload;
  },
  getsetting(state, payload) {
    state.setting = payload;
  },
  
}
const	actions = {
  
  reqActivityReview( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/getReviewlist",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res);
        commit('getactivityreview', result.data)
        r();
      }).catch(() => {
        j();
      })
    })    
  },
  
  reqActivityReviewCount( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/getReviewCount",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res);
        commit('getactivityreviewcount', result.data)
        r();
      }).catch(() => {
        j();
      })
    })    
  },

  reqActivityReviewSetting( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/hcmCustomModel/getListByCampaignReview",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res);
        commit('getsetting', result.data);
        r(result.data);
      }).catch(() => {
        j();
      })
    })    
  },

  reqActivityReviewDetail( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/getReviewlistdetails",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        let result = JSON.parse(res);
        commit('getactivityreviewdetail', result.data)
        r();
      }).catch(() => {
        j();
      })
    })    
  },

  reqActivityAddReview( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/campgign/insertReviewByList",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then((res) => {
        r();
      }).catch(() => {
        j();
      })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}